'use client';

import colors from '@/constants/theme/colors';
import { Flex, FlexProps, Text, useDisclosure } from '@chakra-ui/react';
import {
  Popover,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverAnchor,
  Box,
} from '@chakra-ui/react';

import { FC } from 'react';
import { ArrowDownSLineIcon } from '@/components/Icons';
import { SortOption, sortOptions } from '@/components/Product/SortBy/constants';
import { ISortOption } from '@/components/Product/SortBy/types';
import SortOptions from '@/components/Product/SortBy/SortOptions';

type DesktopSortByProps = {
  sortBy?: ISortOption;
  onSortByChange?: (val: ISortOption) => void;
};
const DesktopSortBy: FC<DesktopSortByProps> = ({
  sortBy = SortOption.priceDesc,
  onSortByChange,
}) => {
  return (
    <Flex
      alignItems="center"
      gap="0.5rem"
      display={{ base: 'none', lg: 'flex' }}
    >
      <Text
        fontSize="0.75rem"
        color={colors.primary[100]}
        fontWeight="300"
        letterSpacing="-0.06px"
      >
        Sort by
      </Text>
      <SortSelector value={sortBy} onChange={onSortByChange} />
    </Flex>
  );
};

interface SortSelectorProps {
  value: ISortOption;
  onChange?: (val: ISortOption) => void;
}
const SortSelector: FC<SortSelectorProps> = ({ value, onChange }) => {
  const { isOpen, onClose, onToggle } = useDisclosure();

  return (
    <Box zIndex="20">
      <Popover isOpen={isOpen} onClose={onClose} placement="bottom-start">
        <SortAnchor onClick={onToggle} selectedOption={value} />
        <PopoverContent>
          <PopoverArrow />
          <PopoverBody>
            <Box onClick={onToggle}>
              <SortOptions value={value} onChange={onChange} />
            </Box>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};

interface SortAnchorProps {
  onClick?: FlexProps['onClick'];
  selectedOption: ISortOption;
}
const SortAnchor: FC<SortAnchorProps> = ({ onClick, selectedOption }) => {
  return (
    <PopoverAnchor>
      <Flex
        cursor="pointer"
        onClick={onClick}
        color={colors.primary[100]}
        border={`1px solid ${colors.primary[50]}`}
        p="0.625rem 1rem"
        alignItems="center"
        gap="0.375rem"
      >
        <Text fontSize="0.875rem" lineHeight="1.25rem">
          {selectedOption.name}
        </Text>
        <ArrowDownSLineIcon size="1rem" />
      </Flex>
    </PopoverAnchor>
  );
};

export default DesktopSortBy;
